import { render, staticRenderFns } from "./CidadeCard.vue?vue&type=template&id=11128cdd&scoped=true"
import script from "./CidadeCard.vue?vue&type=script&lang=js"
export * from "./CidadeCard.vue?vue&type=script&lang=js"
import style0 from "./CidadeCard.vue?vue&type=style&index=0&id=11128cdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11128cdd",
  null
  
)

export default component.exports